import { RootState } from 'store/rootSlices';

export const getPersonalDataSlice = (state: RootState) => state.PersonalData;
export const getUserNmec = (state: RootState) => state.App.user.nmec;
export const getUser = (state: RootState) => state.App.user;
export const getPersonalDataBlocks = (state: RootState) => state.PersonalData.personalDataBlocks;
export const getHasRegistrationId = (state: RootState) => state.PersonalData.hasRegistrationId;
